module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp2_7042.2004c01c.png";